module.exports = __webpack_public_path__ + "static/media/feedback-menu-item.d788f63e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedback-menu-item.svg
// module id = 177
// module chunks = 0